<div class="container actionsTop col-12">
  <div class="btns-actions">
    <button pButton type="button" (click)="showModalVagas = true" class="btn-filter">
      <i class="pi pi-search"></i>
      Filtros
    </button>

    <div *ngIf="totalVagas > 0">
      <button type="button" class="btn-exportar pdf" (click)="downloadPdf()">
        <i class="pi pi-file-pdf"></i>
        Exportar Relatório PDF
      </button>
      <button type="button" class="btn-exportar excel p-button-success" (click)="downloadExcel()">
        <i class="pi pi-file-excel"></i>
        Exportar Relatório Excel
      </button>
    </div>
  </div>


  <div class="data-filter mt-3" *ngIf="totalVagas > 0">
    <div class="flex justify-content-between align-items-center w-full">
      <span class="fw-bold">
        {{ totalVagas }} Vagas encontradas
        <span class="text-500 font-normal ml-2" *ngIf="pagination.totalPages && pagination.totalPages > 1">
          (Página {{ pagination.pageNumber }} de {{ pagination.totalPages }})
        </span>
      </span>
    </div>
    <article *ngIf="appliedFiltersVagas.length > 0">
      <p>Filtros Aplicados</p>
      <div class="filter">
        <span *ngFor="let filter of appliedFiltersVagas">{{filter.label}}: {{filter.value}} </span>
      </div>
    </article>
  </div>

  <app-table class="w-100" *ngIf="totalVagas > 0" [pagination]="pagination" [columns]="columnsVagas"
    (pageChange)="onPageChange($event)">
  </app-table>

  <div class="flex flex-column align-items-center justify-content-center p-5 w-full" *ngIf="carregando">
    <i class="pi pi-spin pi-spinner text-primary" style="font-size: 2.5rem"></i>
    <span class="mt-3 text-600 font-medium">A consultar vagas e a gerar relatório...</span>
  </div>

  <div class="no-data w-full" *ngIf="totalVagas === 0 && !carregando">
    <app-data-void titulo="Nenhum relatório encontrado"
      descricao="Clique em filtros e aplique um filtro para iniciar"></app-data-void>
  </div>
</div>

<p-toast />

<p-dialog header="Filtros de Vagas de Empregos" [draggable]="false" [modal]="true" [(visible)]="showModalVagas"
  [style]="{ width: '42rem' }" [closable]="true">

  <form [formGroup]="formVagas" class="SetBorder">
    <div class="p-fluid grid">
      <div class="field col-12 d-flex flex-column">
        <label for="titulo">Tipo de Relatório</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="titulo" formControlName="titulo"
          [options]="titlleOptionsVagas" optionLabel="label" optionValue="value" placeholder="Seleccione o título"
          class="w-full"></p-select>
        <small class="p-error"
          *ngIf="formVagas.get('titulo')?.invalid && formVagas.get('titulo')?.touched">
          O tipo do relatório é obrigatório.
        </small>
      </div>
      <div class="field col-6 d-flex flex-column">
        <label for="subsector">Subsector</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="subsector" formControlName="subsector"
          [options]="subSectorList" optionLabel="label" optionValue="value" placeholder="Seleccione o subsector"
          class="w-full">
        </p-select>
      </div>
      <div class="field col-6 d-flex flex-column">
        <label for="profissao">Profissão de Referência</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="profissao" formControlName="profissao"
          [options]="profissaoList" optionLabel="label" optionValue="label"
          placeholder="Seleccione a profissão de referência" class="w-full">
        </p-select>
      </div>
      <div class="field col-6 d-flex flex-column">
        <label for="especialidade">Especialidade</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="especialidade" formControlName="especialidade"
          [options]="especialidadeList" optionLabel="label" optionValue="label" placeholder="Seleccione a especialidade"
          class="w-full">
        </p-select>
      </div>
      <div class="field col-6 d-flex flex-column">
        <label for="grupWork">Grupo de Trabalho</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="grupWork" formControlName="grupWork"
          [options]="groupPersonList" optionLabel="label" optionValue="value" placeholder="Seleccione o grupo"
          class="w-full">
        </p-select>
      </div>
      <div class="field col-6 d-flex flex-column">
        <label for="regime">Regime de Trabalho</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="regime" formControlName="regime"
          [options]="regimeList" optionLabel="label" optionValue="id" placeholder="Seleccione o regime" class="w-full">
        </p-select>
      </div>
      <div class="field col-6 d-flex flex-column">
        <label for="habilitacaoAcademica">Habilitações Académicas</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="habilitacaoAcademica"
          formControlName="habilitacaoAcademica" [options]="habilitacaoList" optionLabel="label" optionValue="label"
          placeholder="Seleccione a habilitação" class="w-full">
        </p-select>
      </div>
      <div class="field col-6 d-flex flex-column">
        <label for="ProfissionalExperiencia">Experiência Profissional</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="ProfissionalExperiencia"
          formControlName="ProfissionalExperiencia" [options]="experienciaList" optionLabel="label" optionValue="value"
          placeholder="Seleccione os anos de Experiência" class="w-full">
        </p-select>
      </div>
      <div class="field col-6 d-flex flex-column">
        <label for="empresaSector">Empresa do sector</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="empresaSector" formControlName="empresaSector"
          [options]="empresaSectorList" optionLabel="label" optionValue="value" placeholder="Seleccione a empresa"
          class="w-full">
        </p-select>
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-between align-items-center w-full flex-wrap gap-2">
      <button
        pButton
        type="button"
        label="Limpar Filtros"
        icon="pi pi-filter-slash"
        severity="secondary"
        [text]="true"
        (click)="limparFiltrosVagas()">
      </button>

      <div class="flex gap-2 flex-wrap">
        <button
          pButton
          type="button"
          label="Cancelar"
          icon="pi pi-times"
          severity="secondary"
          [outlined]="true"
          (click)="showModalVagas = false">
        </button>

        <button
          pButton
          type="button"
          label="Emitir PDF"
          icon="pi pi-file-pdf"
          class="p-button-danger p-button-outlined"
          (click)="emitirPdfComFiltros()">
        </button>

        <button
          pButton
          type="button"
          label="Emitir Excel"
          icon="pi pi-file-excel"
          class="p-button-success p-button-outlined"
          (click)="emitirExcelComFiltros()">
        </button>

        <button
          pButton
          type="button"
          label="Emitir Relatório"
          icon="pi pi-check"
          [loading]="carregando"
          (click)="onSubmitVagas()">
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>
